import OfflinePage from "../pages/offline.vue";
import Home from "../pages/home.vue";
import NotFoundPage from "../pages/not-found.vue";
import Dashboard from "../pages/dashboard.vue";
import Tamtam from "../pages/tamtam.vue";
import TamtamMessage from "../pages/tamtamMessage.vue";
import UserProfile from "../pages/userprofile.vue";
import UserProfileEdit from "../pages/userprofileedit.vue";
import Users from "../components/users.vue";
import MyTransactionStatus from "../pages/mytransactionStatus.vue";
import ShopCreation from "../pages/shopCreation.vue";
import AvocashCreateGroup from "../pages/avocashCreateGroup.vue";
import AvocashGroupHome from "../pages/avocashGroupHome.vue";
import GroupsPage from "../pages/GroupsPage.vue";
import AvocashCampaignCreate from "../pages/avocashCampaignCreate.vue";
import AvocashGroupCampaignList from "../pages/avocashCampaignList.vue"
import AvocashCampaignDetail from "../pages/avocashCampaignDetail.vue";
import AvocashGroupMembers from "../pages/avocashGroupMembers.vue";
import AvocashGroupMembersImport from "../pages/avocashGroupMembersImport.vue";
import AvocashGroupDocuments from "../pages/avocashGroupDocuments.vue";
import KycIndividual from "../pages/kycIndividual.vue";
import KycOrganization from "../pages/kycOrganization.vue";
import PayoutRecipientSetup from "../pages/payoutRecipientSetup.vue";
import InvitationAccept from "../pages/invitationAccept.vue";
import AvocashGroupCalendar from "../pages/avocashGroupCalendar.vue";
import AvocashGroupMarketplace from "../pages/avocashGroupMarketplace.vue";
import AvocashGroupMarketplaceCreate from "../pages/avocashGroupMarketplaceCreate.vue";
import AvocashGroupFinancialSetup from "../pages/avocashGroupFinancialSetup.vue";
import SaveToBuyHome from "../pages/saveToBuyHome.vue";
import SaveToBuyCreate from "../pages/saveToBuyCreate.vue";
import SaveToBuyCampaignDetail from "../pages/saveToBuyCampaignDetail.vue";
import SaveToBuyDemandRequest from "../pages/saveToBuyDemandRequest.vue";
import GroupBuyHome from "../pages/groupBuyHome.vue";
import GroupBuyCreate from "../pages/groupBuyCreate.vue";
import GroupBuyCampaignDetail from "../pages/groupBuyCampaignDetail.vue";
import TontineHomePage from "../pages/tontine/TontineHomePage.vue";
import TontineSetupPage from "../pages/tontine/TontineSetupPage.vue";
import TontineCyclePage from "../pages/tontine/TontineCyclePage.vue";
import TontineContributionPage from "../pages/tontine/TontineContributionPage.vue";
import TontinePayoutPage from "../pages/tontine/TontinePayoutPage.vue";
import TontineRulesPage from "../pages/tontine/TontineRulesPage.vue";
import TontineLedgerPage from "../pages/tontine/TontineLedgerPage.vue";
import AvocashAdDashboard from "../pages/avocashAdDashboard.vue";
import AvocashAdCreate from "../pages/avocashAdCreate.vue";
import AdminDashboard from "../pages/adminDashboard.vue";
import MarketplaceDashboard from "../pages/marketplaceDashboard.vue";
import GroupDashboard from "../pages/groupDashboard.vue";
import AccountDetails from "../pages/accountDetails.vue";
import AccountWallet from "../pages/accountWallet.vue";
import Notification from "../pages/notification.vue";
import ManageFeedItems from "../components/feed/ManageFeedItems.vue";
import Payment from "../pages/payment.vue";
import Invitation from "../pages/invitation.vue";
import InvitationList from "../pages/invitationList.vue";
import ShareTarget from "../pages/shareTarget.vue";
import PanelRight from "../pages/panel-right.vue";
import Login from "../pages/login.vue";
import PaymentLinkPage from "../pages/paymentLinkPage.vue";
import GrowthDashboard from "../pages/growthDashboard.vue";
import GrowthAchievements from "../pages/growthAchievements.vue";
import GrowthHealth from "../pages/growthHealth.vue";
import GrowthSepndCredits from "../pages/growthSpendCredits.vue";
import GrowthAdminRewards from "../pages/growthAdminpRewardPanel.vue";
import GrowthAdminCampaigns from "../pages/growthAdminCampaigns.vue";
import PublicShopPage from "../pages/PublicShopPage.vue";
import ShopUpgradeWizard from "../pages/ShopUpgradeWizard.vue";
import CatalogImporterPage from "../pages/CatalogImporterPage.vue";
import ShopProductPage from "../pages/ShopProductPage.vue";
import SellerHub from "../pages/sellerHub.vue";
import SellerProfile from "../components/marketplace/SellerProfile.vue";
import MyListings from "../components/marketplace/MyListings.vue";
import ListingSubmit from "../components/marketplace/ListingSubmit.vue";
import GroupListingManager from "../components/marketplace/GroupListingManager.vue";
import SharedCartPage from "../pages/SharedCartPage.vue";
import ShopCart from "../pages/shopCart.vue";
import ShopCheckout from "../pages/shopCheckout.vue";
import ShopOrders from "../pages/shopOrders.vue";
import { Capacitor } from "@capacitor/core";
import { useKeycloakStore } from "./pinia-stores/keycloak.js";
import {
  captureIntentUrl,
  setIntentUrl,
} from "./composables/useSessionGuard.js";

function redirectToLoginForRoute(url, path) {
  const keycloakStore = useKeycloakStore();
  setIntentUrl(url);
  const redirectUri = Capacitor.isNativePlatform()
    ? "avocash://login" + (path || "/")
    : window.location.origin + (url || "/");
  keycloakStore
    .login({ redirectUri, locale: keycloakStore.locale })
    .catch(() => {});
}

function ifAuthenticated({ to, from, resolve, reject }) {
  const keycloakStore = useKeycloakStore();

  const proceed = () => {
    if (keycloakStore.authenticated) {
      console.log("User is authenticated.");
      captureIntentUrl();
      if (resolve) resolve();
      return;
    }

    console.log(
      "Unauthenticated access to protected route, redirecting to Keycloak:",
      to?.url || to?.path,
    );
    redirectToLoginForRoute(to?.url || to?.path, to?.path);
    if (reject) reject();
  };

  if (!keycloakStore.initialized && !keycloakStore._initializing) {
    console.log("Initializing Keycloak...");
    keycloakStore
      .initialize()
      .then(() => proceed())
      .catch(() => proceed());
    return;
  }

  if (keycloakStore._initializing) {
    console.log("Waiting for Keycloak initialization...");
    keycloakStore._initializing
      .then(() => proceed())
      .catch(() => proceed());
    return;
  }

  proceed();
}

export function guardInitialRoute(route, router) {
  const keycloakStore = useKeycloakStore();
  if (!route?.route?.beforeEnter) return;
  if (keycloakStore.authenticated) return;

  const url = route.url || route.path;
  console.log(
    "Initial deep link is a protected route, redirecting to Keycloak:",
    url,
  );
  if (router) router.navigate("/");
  redirectToLoginForRoute(url, route.path);
}

const routes = [
  {
    path: "/",
    name: "main_page",
    component: Home,
  },
  {
    path: "/dashboard/",
    id: "view-dashboard",
    name: "dashboard",
    component: Dashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/dashboard/admin",
    name: "admin_dashboard",
    component: AdminDashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/dashboard/marketplace",
    name: "marketplace_dashboard",
    component: MarketplaceDashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/message/",
    name: "tamtam_main_page",
    component: Tamtam,
    master: true,

    beforeEnter: ifAuthenticated,
    detailRoutes: [
      {
        path: "/message/:id/:type",
        name: "tamtam_detail_page",
        component: TamtamMessage,
        beforeEnter: ifAuthenticated,
      },
    ],
  },
  {
    path: "/message/:id/:type",
    name: "tamtam_detail_page",
    component: TamtamMessage,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/group/message/:id/:type",
    name: "group_tamtam_detail_page",
    component: TamtamMessage,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/user/profile",
    name: "user_detail_page",
    component: UserProfile,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/user/profile/edit",
    name: "edit_user_profile",
    component: UserProfileEdit,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/users",
    name: "users_list",
    component: Users,
    beforeEnter: ifAuthenticated,
  },


  {
    path: "/transaction/:result_type/:transactionId",
    alias: "/transaction/:result_type",
    name: "transaction_status",
    component: MyTransactionStatus,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/shop/create",
    name: "shop_creation",
    component: ShopCreation,
    alias: "/shop/new",
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/sell",
    name: "seller_hub",
    component: SellerHub,
    alias: "/shops",
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/sell/profile",
    name: "seller_profile",
    component: SellerProfile,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/sell/listings",
    name: "my_listings",
    component: MyListings,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/sell/listings/:listingId/submit",
    name: "listing_submit",
    component: ListingSubmit,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/marketplace/admin",
    name: "group_listing_manager",
    component: GroupListingManager,
    props: true,
    beforeEnter: ifAuthenticated,
  },

  {
    path: "/shop-public/:shopId",
    name: "shop_public",
    component: PublicShopPage,
  },
  {
    path: "/shop/:shopId/community/upgrade",
    name: "shop_community_upgrade",
    component: ShopUpgradeWizard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/shop/:shopId/catalog/import",
    name: "catalog_importer",
    component: CatalogImporterPage,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/shop-product/:productId",
    name: "shop_product",
    component: ShopProductPage,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/shared-cart/:cartId",
    name: "shared_cart",
    component: SharedCartPage,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/cart",
    name: "shop_cart",
    component: ShopCart,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/checkout/:cartId",
    name: "shop_checkout",
    component: ShopCheckout,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/orders",
    name: "shop_orders",
    component: ShopOrders,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/group/new",
    name: "group_create",
    component: AvocashCreateGroup,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/kyc/individual/:groupId",
    name: "kyc_individual",
    component: KycIndividual,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/kyc/organization/:groupId",
    name: "kyc_organization",
    component: KycOrganization,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/payout-recipient-setup",
    name: "payout_recipient_setup",
    component: PayoutRecipientSetup,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/",
    name: "groups_list",
    component: GroupsPage,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId",
    name: "group_home",
    component: AvocashGroupHome,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/create",
    name: "campaign_create",
    component: AvocashCampaignCreate,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId",
    name: "campaign_detail",
    component: AvocashCampaignDetail,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns",
    name: "campaign_list",
    component: AvocashGroupCampaignList,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/members",
    name: "group_members",
    component: AvocashGroupMembers,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/members/import",
    name: "group_members_import",
    component: AvocashGroupMembersImport,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/dashboard",
    name: "group_dashboard",
    component: GroupDashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/documents",
    name: "group_documents",
    component: AvocashGroupDocuments,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/calendar/",
    name: "group_calendar",
    component: AvocashGroupCalendar,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/marketplace",
    name: "group_marketplace",
    component: AvocashGroupMarketplace,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/marketplace/create",
    name: "group_marketplace_create",
    component: AvocashGroupMarketplaceCreate,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/financial-setup",
    name: "group_financial_setup",
    component: AvocashGroupFinancialSetup,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/save-to-buy",
    name: "group_save_to_buy",
    component: SaveToBuyHome,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/save-to-buy/create/:offerId",
    name: "group_save_to_buy_create",
    component: SaveToBuyCreate,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/save-to-buy/campaigns/:campaignId",
    name: "group_save_to_buy_campaign",
    component: SaveToBuyCampaignDetail,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/save-to-buy/demand",
    name: "group_save_to_buy_demand",
    component: SaveToBuyDemandRequest,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/group-buy",
    name: "group_group_buy",
    component: GroupBuyHome,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/group-buy/create/:productId?",
    name: "group_group_buy_create",
    component: GroupBuyCreate,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/group-buy/campaigns/:campaignId",
    name: "group_group_buy_campaign",
    component: GroupBuyCampaignDetail,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId/tontine",
    name: "group_tontine_home",
    component: TontineHomePage,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId/tontine/setup",
    name: "group_tontine_setup",
    component: TontineSetupPage,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId/tontine/cycles/:cycleId",
    name: "group_tontine_cycle",
    component: TontineCyclePage,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId/tontine/contributions/:contributionId",
    name: "group_tontine_contribution",
    component: TontineContributionPage,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId/tontine/payouts/:payoutId",
    name: "group_tontine_payout",
    component: TontinePayoutPage,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId/tontine/rules",
    name: "group_tontine_rules",
    component: TontineRulesPage,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/campaigns/:campaignId/tontine/ledger",
    name: "group_tontine_ledger",
    component: TontineLedgerPage,
    props: true,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/growth/",
    name: "group_growth_dashboard",
    component: GrowthDashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/growth/achievements/",
    name: "group_growth_achievements",
    component: GrowthAchievements,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/growth/health/",
    name: "group_growth_health",
    component: GrowthHealth,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/growth/spend-credits/",
    name: "group_growth_spend_credits",
    component: GrowthSepndCredits,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/growth/admin/rewards/",
    name: "group_growth_admin_rewards",
    component: GrowthAdminRewards,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/groups/:groupId/growth/admin/campaigns/",
    name: "group_growth_admin_campaigns",
    component: GrowthAdminCampaigns,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/community-growth/",
    name: "community_growth_dashboard",
    component: GrowthDashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/achievements/",
    name: "community_growth_achievements",
    component: GrowthAchievements,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/community-health/",
    name: "community_growth_health",
    component: GrowthHealth,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/spend-credits/",
    name: "community_growth_spend_credits",
    component: GrowthSepndCredits,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/growth/admin/rewards/",
    name: "community_growth_admin_rewards",
    component: GrowthAdminRewards,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/growth/admin/campaigns/",
    name: "community_growth_admin_campaigns",
    component: GrowthAdminCampaigns,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/ads",
    name: "ad_dashboard",
    component: AvocashAdDashboard,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/ads/create",
    name: "ad_create",
    component: AvocashAdCreate,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/account/:type/:account_id",
    name: "account_details",
    component: AccountDetails,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/account/:account_id/wallet/:wallet_id",
    name: "account_wallet",
    component: AccountWallet,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/notification/",
    name: "notificationsPage",
    component: Notification,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/feed/manage",
    name: "manage_feed",
    component: ManageFeedItems,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/pay/:paymentLinkId",
    name: "paymentPage",
    component: Payment,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/invite/:invitationId",
    name: "invitationPage",
    component: Invitation,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/invitations/",
    name: "invitationsPage",
    component: InvitationList,
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/invitations/:token",
    name: "invitation_accept",
    component: InvitationAccept,
  },
  {
    path: "/share-target",
    name: "share-target",
    component: ShareTarget,
  },
  {
    path: "/panel-right",
    name: "panel-right",
    component: PanelRight,
  },
  {
    path: "/offline",
    name: "offline",
    component: OfflinePage,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },

  {
    path: "/p/:slug",
    name: "paymentLinkProduct",
    component: PaymentLinkPage,
    props: { path: "p" },
  },
  {
    path: "/c/:slug",
    name: "paymentLinkCampaign",
    component: PaymentLinkPage,
    props: { path: "c" },
  },
  {
    path: "/i/:token",
    name: "paymentLinkPrivate",
    component: PaymentLinkPage,
    props: { path: "i" },
    beforeEnter: ifAuthenticated,
  },
  {
    path: "(.*)",
    component: NotFoundPage,
  },
];

export default routes;
